import React from 'react';
import i18n from '../../utils/i18n';
import './index.scss';

/**
 * Compact prev / next control with a minimal page indicator (e.g. 3 / 12).
 */
export default function CompactPagination({
  currentPage = 1,
  pageCount,
  onPageChange,
  className = '',
}) {
  const safeCurrent = Math.min(
    Math.max(1, Number(currentPage) || 1),
    Math.max(1, Number(pageCount) || 1),
  );
  const safeTotal = Math.max(1, Number(pageCount) || 1);
  const canPrev = safeCurrent > 1;
  const canNext = safeCurrent < safeTotal;

  const a11yLabel = i18n.t('corporateDashboard.pagination.a11y', {
    current: safeCurrent,
    total: safeTotal,
    defaultValue: 'Page {{current}} of {{total}}',
  });

  const goPrev = () => {
    if (canPrev) {
      onPageChange(safeCurrent - 1);
    }
  };

  const goNext = () => {
    if (canNext) {
      onPageChange(safeCurrent + 1);
    }
  };

  return (
    <nav
      className={`compact-pagination ${className}`.trim()}
      aria-label={a11yLabel}
    >
      <button
        type='button'
        className='compact-pagination__btn compact-pagination__btn--prev'
        onClick={goPrev}
        disabled={!canPrev}
        aria-label={i18n.t('corporateDashboard.pagination.prev', {
          defaultValue: 'Previous page',
        })}
      >
        <img src='/assets/icons/paginate-arrow.svg' alt='' aria-hidden />
      </button>
      <span className='compact-pagination__status' aria-live='polite'>
        {a11yLabel}
      </span>
      <button
        type='button'
        className='compact-pagination__btn compact-pagination__btn--next'
        onClick={goNext}
        disabled={!canNext}
        aria-label={i18n.t('corporateDashboard.pagination.next', {
          defaultValue: 'Next page',
        })}
      >
        <img src='/assets/icons/paginate-arrow.svg' alt='' aria-hidden />
      </button>
    </nav>
  );
}
